import { PageLocatorMap } from '../types/PageLocatorMap';

export const applicantAddCoapplicantPage = {
  alert: {
    error: 'applicant-add-coapplicant.alert.error',
  },
  footer: {
    root: 'applicant-add-coapplicant.footer.root',
  },
  form: {
    h1: 'applicant-add-coapplicant.form.h1',
    h2: 'applicant-add-coapplicant.form.h2',
    radioGroupRoot: 'applicant-add-coapplicant.form.radio-group-root',
    radioOption1: 'applicant-add-coapplicant.form.radio-option-1',
    radioOption2: 'applicant-add-coapplicant.form.radio-option-2',
    root: 'applicant-add-coapplicant.form.root',
    submitButton: 'applicant-add-coapplicant.form.submit-button',
  },
  header: {
    previousStepButton: 'applicant-add-coapplicant.header.previous-step-button',
    root: 'applicant-add-coapplicant.header.root',
    toggleDrawerButton: 'applicant-add-coapplicant.header.drawer-button',
  },
  progress: {
    root: 'applicant-add-coapplicant.progress.root',
  },
} as const satisfies PageLocatorMap;
